export const API_BASE_URL = "https://geotech.julesferry-ga.com/api";